<div class="container">
  <div class="item">
    <span [class.before]="!connected"></span>
    <span [class.after]="!connected"></span>
  </div>
</div>
